import React from "react";
import { ArrowUp, ArrowDown } from "lucide-react";

export default function StatCard({
  icon: Icon,
  title,
  value,
  delta,
  trend = "up",
  onClick,
}) {
  const trendColor = trend === "up" ? "text-green-500" : "text-red-500";
  const trendIcon =
    trend === "up" ? (
      <ArrowUp className="w-4 h-4 inline-block" />
    ) : (
      <ArrowDown className="w-4 h-4 inline-block" />
    );

  return (
    <div
      onClick={onClick}
      className="flex flex-col items-start p-3 bg-white shadow-sm rounded-lg transition w-full"
    >
      {/* Top: Icon and Title */}
      <div className="flex items-center gap-2 mb-1">
        {Icon && <Icon className="w-5 h-5 text-gray-600" />}
        <p className="text-sm font-medium text-gray-500">{title}</p>
      </div>

      {/* Middle: Value */}
      <p className="text-xl font-semibold text-gray-800">{value}</p>

      {/* Bottom: Delta / Trend */}
      {delta && (
        <p className={`text-sm font-medium mt-1 ${trendColor}`}>
          {trendIcon} <span className="ml-1">{delta}</span>
        </p>
      )}
    </div>
  );
}
